/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Plan_WordsInputs */

const en_us2_search_plan_words = /** @type {(inputs: Search_Plan_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`plan workout routine`)
};

const pt_br2_search_plan_words = /** @type {(inputs: Search_Plan_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`plano treino ficha`)
};

const es_419_search_plan_words = /** @type {(inputs: Search_Plan_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`plan entrenamiento rutina`)
};

const pt_pt2_search_plan_words = /** @type {(inputs: Search_Plan_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`plano treino ficha rotina`)
};

const fr_fr2_search_plan_words = /** @type {(inputs: Search_Plan_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`programme seance routine plan`)
};

const de_de2_search_plan_words = /** @type {(inputs: Search_Plan_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`plan trainingsplan training routine`)
};

const it_it2_search_plan_words = /** @type {(inputs: Search_Plan_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`scheda piano allenamento routine`)
};

/**
* | output |
* | --- |
* | "plan workout routine" |
*
* @param {Search_Plan_WordsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_plan_words = /** @type {((inputs?: Search_Plan_WordsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Plan_WordsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_plan_words(inputs)
	if (locale === "es-419") return es_419_search_plan_words(inputs)
	if (locale === "pt-PT") return pt_pt2_search_plan_words(inputs)
	if (locale === "fr-FR") return fr_fr2_search_plan_words(inputs)
	if (locale === "de-DE") return de_de2_search_plan_words(inputs)
	if (locale === "it-IT") return it_it2_search_plan_words(inputs)
	return en_us2_search_plan_words(inputs)
});
export { search_plan_words as "search.plan_words" }